import {
	Button,
	Card,
	CardBody,
	EmptyState,
	EmptyStateBody,
	EmptyStateFooter,
	Stack,
	StackItem,
} from "@patternfly/react-core";
import { ExclamationTriangleIcon } from "@patternfly/react-icons";
import { useControllerContext } from "@rhc-shared-components/control-wrapper";
import { type FC, useState } from "react";
import { useProductMetadata } from "../../hooks/useProductMetadata";
import { ComponentCreateModal } from "./CreateComponentsModal/CreateComponentModal";
import ProductComponentsTable from "./ProductComponentsTable";
import "./ProductComponents.scss";

export const ProductComponents: FC = () => {
	const { certificationListState, globalDisabledState } = useProductMetadata();
	const [showCreateComponentModal, setCreateComponentModal] = useState(false);
	const { isReadOnly } = useControllerContext();
	const handleCreateModal = (data: boolean) => {
		setCreateComponentModal(data);
	};
	const ProductComponentModals: FC = () => (
		<>
			<ComponentCreateModal isVisible={showCreateComponentModal} handleCreateModal={handleCreateModal} />
		</>
	);

	if (certificationListState?.length === 0) {
		return (
			<>
				<EmptyState
					icon={() => {
						return <ExclamationTriangleIcon color={"var(--pf-t--global--color--status--warning--default)"} />;
					}}
					data-analytics-category="Product Info|Tabs|Components"
				>
					<EmptyStateBody>This product has no components attached.</EmptyStateBody>
					<EmptyStateFooter>
						<Button
							variant="secondary"
							isDisabled={isReadOnly || globalDisabledState}
							onClick={() => {
								setCreateComponentModal(true);
							}}
						>
							Add component
						</Button>
					</EmptyStateFooter>
				</EmptyState>
				<ProductComponentModals />
			</>
		);
	}
	return (
		<>
			<Card className={"manage-product-component"} data-analytics-category="Product Info|Tabs|Components">
				<CardBody>
					<Stack hasGutter>
						<StackItem>
							<ProductComponentsTable />
						</StackItem>
					</Stack>
				</CardBody>
			</Card>
			<ProductComponentModals />
		</>
	);
};
